import * as d3 from 'd3'
export default {
  methods: {

    openStage(props) {
      this.winProps = {exeFunc: this.stage_Router, idx: props.idx, width: 600, height: 450, mode: 'stage',}
      this.gmx_drawWindow()
    },


    stage_Router(selection) {

      let dia = this.db_Diagram.find(f=> f.IDX == this.winProps.idx)
      let stages = this.db_Stage.filter(f=> f.IDX == this.winProps.idx)

      for(let i=stages.length+1; i<6; i++) {
        stages.push({
          IDX: this.winProps.idx,
          STG_NO: i, 
          PHASE: dia.PHASE,
          DIAGRAM: dia.DIAGRAM,
        })
      }

      let diaForm = selection
      .append('g')
      .attr('transform', `translate(0, 0)`)

      diaForm
      .append('text')
      .attr('x', 20).attr('y', 28).attr('fill', '#000') .attr('font-size', 17).attr('font-style', 'italic')
      .text('Stage')

      diaForm
      .append('image')
      .attr('xlink:href', this.HOST + `/Database/img/PROJECT_${this.config.project}.png`)
      .attr('x', 30).attr('y', 50).attr('width', 167)

      // Recommended coordinates
      let recommend = diaForm
      .append('g')
      .attr('transform', `translate(370, 115)`)

      recommend
      .append('text')
      .attr('x', 25).attr('y', 0).attr('fill', '#FAAA18') .attr('font-size', 10).attr('font-style', 'italic')
      .text('Recommended Values')
      .attr('opacity', 1).attr('cursor', 'pointer')
      .on('mouseover', function() {
        d3.select(this).attr('opacity', .5)
      })
      .on('mouseout', function() {
        d3.select(this).attr('opacity', 1)
      })
      .on('click', () => {
        this.recommend_Values(selection) // -----> stage_Action.js
      })

      this.gmx_Line(recommend, 0, 0, -3, 10, '#bcbcbc', .5, 1)
      this.gmx_Line(recommend, 0, 22, -3, -3, '#bcbcbc', .5, 1)
      this.gmx_Line(recommend, 150, 150, -3, 10, '#bcbcbc', .5, 1)
      this.gmx_Line(recommend, 150, 128, -3, -3, '#bcbcbc', .5, 1)

      let y_ = 140
      stages.forEach(d=> {

        let inputSet = [
          {id: `STG_NO_${d.STG_NO}`,  label: 'Order',      x: 50,  y: y_, width: 30,  maxLen: 3,  value: d.STG_NO,   type: 'fixed', },
          {id: `STAGE_${d.STG_NO}`,   label: 'Stage name', x: 100, y: y_, width: 230, maxLen: 25, value: d.STAGE,                    lColor: '#44A9DF',},
          {id: `X_${d.STG_NO}`,       label: 'X',          x: 350, y: y_, width: 40,  maxLen: 4,  value: d.X,        type: 'number', align: 'middle', tColor: '#757575'},
          {id: `Y_${d.STG_NO}`,       label: 'Y',          x: 400, y: y_, width: 40,  maxLen: 4,  value: d.Y,        type: 'number', align: 'middle', tColor: '#757575'},
          {id: `WIDTH_${d.STG_NO}`,   label: 'Width',      x: 450, y: y_, width: 40,  maxLen: 4,  value: d.WIDTH,    type: 'number', align: 'middle', tColor: '#757575'},
          {id: `SPACE_${d.STG_NO}`,   label: 'Space',      x: 500, y: y_, width: 40,  maxLen: 4,  value: d.SPACE,    type: 'number', align: 'middle', tColor: '#757575'},
          {id: `IDX_${d.STG_NO}`,     label: 'idx',        x: 620, y: y_, width: 30,  maxLen: 3,  value: d.IDX,      type: 'fixed', },
          {id: `PHASE_${d.STG_NO}`,   label: 'Phase',      x: 650, y: y_, width: 75,  maxLen: 25, value: d.PHASE,    type: 'fixed', },
          {id: `DIAGRAM_${d.STG_NO}`, label: 'Diageam',    x: 750, y: y_, width: 100, maxLen: 25, value: d.DIAGRAM,  type: 'fixed', },
        ] 
        this.gmx_InputBox(diaForm, inputSet)

        y_ += 50
      })


      let buttons = selection
      .append('g')
      .attr('transform', `translate(${this.winProps.width-200}, ${this.winProps.height-50})`)

      buttons
      .append('image') // Save
      .attr('xlink:href', this.HOST + `/Database/btn/Save.svg`)
      .attr('x', 0).attr('y', 0).attr('width', 80).attr('opacity', 1).attr('cursor', 'pointer')
      .on('mouseover', function() {
        d3.select(this).transition().duration(75).attr('opacity', .5)
      })
      .on('mouseout', function() {
        d3.select(this).transition().duration(250).attr('opacity', 1)
      })
      .on('click', () => {
        this.save_Stage(selection) // -----> stage_Action.js
      })

      buttons
      .append('image') // Close
      .attr('xlink:href', this.HOST + `/Database/btn/Close.svg`)
      .attr('x', 95).attr('y', 0).attr('width', 80).attr('cursor', 'pointer')
      .call(this.call_WinClosed) // ----->
    },

  }
}